import { appUrls } from '../../utils/urls/appUrls'

import { 
	
	SearchResult,
	DigitalLetter,
	NotapCertificateView,
	
	EvaluationHistory
 } from '../../app/pages'
import NotapCertificateManagement from '../../app/pages/CertificateManagement/Notap/CertificateManagement'
import TransactionHistory from '../../app/pages/CertificateManagement/TransactionHistory'
import LetterHistory from '../../app/pages/DigitalLetter/LetterHistory'
import PreviousEvaluationHistory from '../../app/pages/CertificateManagement/Notap/PreviousEvaluationHistory'

export const notapRoutes = [
	{
		url: appUrls.notap_certificates,
		component: <NotapCertificateManagement />,
		routeType: 'private'
	},
	// {
	// 	url: appUrls.dashboard,
	// 	component: <Dashboard />,
	// 	routeType: 'private'
	// },
	// {
	// 	url: appUrls.certificates,
	// 	component: <CertificateManagement />,
	// 	routeType: 'private'
	// },
	{
		url: appUrls.notap_certificates_search,
		component: <SearchResult />,
		routeType: 'private'
	},
	{
		url: appUrls.notap_certificates_view,
		component: <NotapCertificateView />,
		routeType: 'private'
	},
	{
		url: appUrls.notap_evaluation_history,
		component: <EvaluationHistory />,
		routeType: 'private'
	},
	{
		url: appUrls.notap_prev_evaluation_history,
		component: <PreviousEvaluationHistory />,
		routeType: 'private'
	},	
	{
		url: appUrls.notap_transaction_history,
		component: <TransactionHistory />,
		routeType: 'private'
	},
	{
		url: appUrls.notap_letter_history,
		component: <LetterHistory />,
		routeType: 'private'
	},
	{
		url: `${appUrls.digitalLetterBase}`,
		component: <DigitalLetter />,
		routeType: 'private'
	},
	// {
	// 	url: appUrls.digital_letters,
	// 	component: <DigitalLetter />,
	// 	routeType: 'private'
	// },
	// {
	// 	url: appUrls.profileCreation,
	// 	component: <ProfileCreation />,
	// 	routeType: 'private'
	// },
	// {
	// 	url: appUrls.profileCreationSuccess,
	// 	component: <ProfileCompletionSuccess />,
	// 	routeType: 'private'
	// },
	// {
	// 	url: appUrls.user_profile,
	// 	component: <UserProfile />,
	// 	routeType: 'private'
	// },
	// {
	// 	url: appUrls.print,
	// 	component: <PrintLetter />,
	// 	routeType: 'private'
	// },	
]
